import qs from 'qs'

const BASE_URL = 'ai-service/api/ai-models'

const aiModelsRequests = {
  addAiModelRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updateAiModelRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  searchAiModelsRequest: ({ searchText, skip = 0, take = 50, attached = true, aiObjectsIds = [] }) => ({
    url: BASE_URL,
    method: 'get',
    params: {
      attached,
      aiObjectsIds,
      search: searchText,
      skip,
      take,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),
  getUnattachedAiModelsRequest: ({ filters = {}, pageNumber = 1, pageSize = 25 }) => ({
    url: `${BASE_URL}/unattached`,
    method: 'get',
    params: {
      ...filters,
      skip: (pageNumber - 1) * pageSize,
      take: pageSize,
    },
  }),
  publishAiModelRequest: ({ aiModelId, tenants }) => ({
    url: `${BASE_URL}/${aiModelId}/publish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
  unpublishAiModelRequest: ({ aiModelId, tenants }) => ({
    url: `${BASE_URL}/${aiModelId}/unpublish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
}

export default aiModelsRequests
